import { updateItems } from '@/mocks/homeData';

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">最新动态</h2>
            <p className="text-sm text-foreground-600">实时追踪全网吃瓜热点，快人一步掌握最新进展</p>
          </div>
          <a
            href="#ranking"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看热搜榜 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-px bg-background-200"></div>

          <div className="space-y-6 md:space-y-7">
            {updateItems.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-6 pl-12 md:pl-14 group cursor-pointer">
                <div className="absolute left-[11px] md:left-[15px] top-0.5 w-4 h-4 md:w-4.5 md:h-4.5 rounded-full bg-primary-500 ring-4 ring-background-50 group-hover:bg-primary-400 transition-colors"></div>

                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-accent-100/80 text-accent-700 text-[11px] font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-relaxed group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center sm:hidden">
          <a
            href="#ranking"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看热搜榜 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}